/* Personalisiert die feste Shopify-Outreach-Seite über einen opaken Portal-Token. */
(function () {
  'use strict';

  var TOKEN_PATTERN = /^[A-Za-z0-9_-]{24,80}$/;

  function randomId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return String(Date.now()) + '-' + Math.random().toString(36).slice(2);
  }

  function anonymousRecipientRef(attributionToken) {
    if (!window.crypto || !window.crypto.subtle || typeof window.TextEncoder !== 'function') {
      return Promise.resolve(null);
    }
    try {
      var bytes = new window.TextEncoder().encode(attributionToken);
      return window.crypto.subtle.digest('SHA-256', bytes).then(function (buffer) {
        return Array.from(new Uint8Array(buffer)).map(function (byte) {
          return byte.toString(16).padStart(2, '0');
        }).join('').slice(0, 32);
      }).catch(function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }

  function formatNumber(value, options) {
    try { return new Intl.NumberFormat('de-DE', options || {}).format(value); }
    catch (e) { return String(value); }
  }

  function formatDate(value) {
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    try { return new Intl.DateTimeFormat('de-DE').format(date); }
    catch (e) { return ''; }
  }

  function setText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = value;
  }

  function previewData() {
    return {
      entrypoint: 'qr',
      companyName: 'Autohaus Beispiel',
      contactName: 'Max Mustermann',
      campaignName: 'Hamburg Werkstatt-Pilot',
      campaignSlug: 'hamburg-werkstatt-pilot',
      attributionToken: 'ThemeEditorPreviewToken_123456',
      couponCode: 'RF-HAMBUR-DEMO2026',
      discountKind: 'percentage',
      discountValue: 20,
      currency: 'EUR',
      minimumOrderAmount: null,
      startsAt: new Date().toISOString(),
      endsAt: new Date(Date.now() + 30 * 86400000).toISOString(),
      actionUrl: '/pages/angebotsverteilung'
    };
  }

  function validData(data) {
    return data &&
      (data.entrypoint === 'qr' || data.entrypoint === 'purl') &&
      typeof data.companyName === 'string' && data.companyName.length > 0 &&
      typeof data.campaignSlug === 'string' && data.campaignSlug.length > 0 &&
      typeof data.attributionToken === 'string' && TOKEN_PATTERN.test(data.attributionToken) &&
      typeof data.couponCode === 'string' && data.couponCode.length > 0 &&
      (data.discountKind === 'percentage' || data.discountKind === 'fixed') &&
      typeof data.discountValue === 'number' && Number.isFinite(data.discountValue) &&
      typeof data.actionUrl === 'string' && data.actionUrl.length > 0;
  }

  function init(root) {
    var loading = root.querySelector('[data-outreach-loading]');
    var content = root.querySelector('[data-outreach-content]');
    var offer = root.querySelector('[data-outreach-offer]');
    var error = root.querySelector('[data-outreach-error]');
    var token = new URLSearchParams(window.location.search).get('t') || '';
    var designMode = root.getAttribute('data-design-mode') === 'true';
    var apiBase = (root.getAttribute('data-api-base') || '').replace(/\/$/, '');
    var sessionKey = '_rf_outreach_session_' + token;
    var sessionId = '';
    var recipientRefPromise = null;

    try {
      sessionId = sessionStorage.getItem(sessionKey) || randomId();
      sessionStorage.setItem(sessionKey, sessionId);
    } catch (e) { sessionId = randomId(); }

    function track(eventType, metadata) {
      if (designMode || !TOKEN_PATTERN.test(token)) return;
      fetch(apiBase + '/' + encodeURIComponent(token) + '/events', {
        method: 'POST',
        mode: 'cors',
        referrerPolicy: 'no-referrer',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          eventType: eventType,
          sessionId: sessionId,
          eventId: randomId(),
          metadata: metadata || {}
        })
      }).catch(function () { /* Tracking darf die Seite nie blockieren. */ });
    }

    function capturePostHog(eventName, data, extra) {
      if (designMode || !window.posthog || typeof window.posthog.capture !== 'function') return;
      if (!recipientRefPromise) recipientRefPromise = anonymousRecipientRef(data.attributionToken);
      recipientRefPromise.then(function (recipientRef) {
        if (!recipientRef) return;
        window.posthog.capture(eventName, Object.assign({
          campaign: data.campaignSlug,
          entrypoint: data.entrypoint,
          recipient_ref: recipientRef,
          page_path: '/pages/werkstatt-aktion',
          discount_kind: data.discountKind,
          discount_value: data.discountValue,
          has_minimum_order_amount: typeof data.minimumOrderAmount === 'number'
        }, extra || {}));
      }).catch(function () { /* Analytics darf die Seite nie blockieren. */ });
    }

    function showError(message) {
      if (loading) loading.hidden = true;
      if (content) content.hidden = true;
      if (offer) offer.hidden = true;
      if (error) error.hidden = false;
      setText(root, '[data-outreach-error-message]', message || 'Bitte prüfen Sie den Link oder wenden Sie sich an RepairFirst.');
    }

    function render(data) {
      var discount = data.discountKind === 'percentage'
        ? formatNumber(data.discountValue) + ' % Rabatt'
        : formatNumber(data.discountValue, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + data.currency + ' Rabatt';
      var greeting = data.contactName
        ? 'Guten Tag ' + data.contactName + ','
        : 'Guten Tag an das Team von ' + data.companyName + ',';
      var validUntil = formatDate(data.endsAt);

      setText(root, '[data-outreach-greeting]', greeting);
      setText(root, '[data-outreach-company]', 'Dieses Angebot ist für ' + data.companyName + ' reserviert.');
      setText(root, '[data-outreach-discount]', discount);
      setText(root, '[data-outreach-code]', data.couponCode);
      setText(root, '[data-outreach-validity]', validUntil ? 'Gültig bis ' + validUntil : 'Zeitlich begrenzte Aktion');

      var minimum = root.querySelector('[data-outreach-minimum]');
      if (minimum && typeof data.minimumOrderAmount === 'number' && Number.isFinite(data.minimumOrderAmount)) {
        minimum.textContent = 'Ab ' + formatNumber(data.minimumOrderAmount, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + data.currency + ' Bestellwert';
        minimum.hidden = false;
      }

      var action = root.querySelector('[data-outreach-action]');
      if (action) {
        action.href = data.actionUrl;
        action.addEventListener('click', function () {
          track('cta_click', { target: 'shopify_anfrage' });
          capturePostHog('outreach_discount_clicked', data, { target: 'shopify_anfrage' });
        });
      }

      var context = {
        campaign: data.campaignSlug,
        attribution: data.attributionToken,
        entrypoint: data.entrypoint
      };
      try {
        localStorage.setItem('_rf_outreach', JSON.stringify({
          campaign: context.campaign,
          attribution: context.attribution,
          entrypoint: context.entrypoint,
          _ts: new Date().toISOString()
        }));
      } catch (e) { /* Cart-Redirect trägt denselben Kontext als Fallback. */ }
      document.dispatchEvent(new CustomEvent('rf:outreach-context', { detail: context }));

      var copy = root.querySelector('[data-outreach-copy]');
      if (copy) {
        copy.addEventListener('click', function () {
          var status = root.querySelector('[data-outreach-copy-status]');
          if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') {
            if (status) status.textContent = 'Code: ' + data.couponCode;
            return;
          }
          navigator.clipboard.writeText(data.couponCode).then(function () {
            if (status) status.textContent = 'Code kopiert';
            window.setTimeout(function () { if (status) status.textContent = ''; }, 1800);
          }).catch(function () {
            if (status) status.textContent = 'Code: ' + data.couponCode;
          });
        });
      }

      if (loading) loading.hidden = true;
      if (error) error.hidden = true;
      if (content) content.hidden = false;
      if (offer) offer.hidden = false;
      track('page_view', { entrypoint: data.entrypoint });
      capturePostHog('outreach_landing_opened', data);
      window.setTimeout(function () {
        track('engaged', { seconds: 10 });
        capturePostHog('outreach_landing_engaged', data, { seconds: 10 });
      }, 10000);
    }

    if (designMode && !TOKEN_PATTERN.test(token)) {
      render(previewData());
      return;
    }
    if (!TOKEN_PATTERN.test(token) || !apiBase) {
      showError('Der persönliche Aktionslink ist unvollständig oder ungültig.');
      return;
    }

    fetch(apiBase + '/' + encodeURIComponent(token), {
      mode: 'cors',
      cache: 'no-store',
      referrerPolicy: 'no-referrer',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        if (!response.ok || !payload.data) throw new Error(payload.error || 'Diese Aktion ist derzeit nicht verfügbar.');
        return payload.data;
      });
    }).then(function (data) {
      if (!validData(data)) throw new Error('Die Aktionsdaten sind unvollständig.');
      render(data);
    }).catch(function (reason) {
      showError(reason instanceof Error ? reason.message : 'Diese Aktion ist derzeit nicht verfügbar.');
    });
  }

  document.querySelectorAll('[data-rf-outreach]').forEach(init);
})();
